import React from 'react';
import { Paper, Text, ActionIcon, Tooltip } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import DataTables from 'components/DataTables';
import type { CoursePlanBusinessUnitForm } from '../../../../types/lcms/coursePlan';

/* eslint-disable */
interface BusinessUnitTableProps {
  dataBusinessUnits: CoursePlanBusinessUnitForm[];
  onRemove: (businessUnitId: string) => void;
  mode?: 'add' | 'edit' | 'view';
}
/* eslint-enable */

const BusinessUnitTable: React.FC<BusinessUnitTableProps> = ({
  dataBusinessUnits,
  onRemove,
  mode = 'add'
}) => {
  const columns = [
    {
      heading: 'Business Unit Name',
      active: true,
      props: (row: CoursePlanBusinessUnitForm) => (
        <Text size='sm' fw={500}>
          {row.businessUnitName}
        </Text>
      )
    },
    {
      heading: 'Actions',
      active: true,
      props: (row: CoursePlanBusinessUnitForm) => (
        <Tooltip label='Remove Business Unit'>
          <ActionIcon
            variant='subtle'
            color='red'
            onClick={() => onRemove(row.businessUnitId)}
            disabled={mode === 'view'}
          >
            <IconTrash size={16} />
          </ActionIcon>
        </Tooltip>
      )
    }
  ];

  if (dataBusinessUnits.length === 0) {
    return (
      <Text c='dimmed' size='sm' style={{ fontStyle: 'italic' }}>
        {mode === 'view'
          ? 'No business units assigned to this plan'
          : 'Click "Add Business Units" to select business units'}
      </Text>
    );
  }

  return (
    <Paper withBorder p={16} radius='lg'>
      <Text fw={500} size='sm' mb={12}>
        Selected Business Units ({dataBusinessUnits.length})
      </Text>
      <DataTables
        data={dataBusinessUnits}
        columns={columns}
        withPagination={false}
        isNumbering={false}
        loading={false}
      />
    </Paper>
  );
};

export default BusinessUnitTable;
